<script setup lang="ts">
import { BookOpenCheck, CheckCircle2, Compass, SearchCheck, ShieldCheck } from "@lucide/vue";
import { computed } from "vue";
import { useContent } from "../composables/useContent";

const { records } = useContent();
const publishedCount = computed(() => records.value.filter((record) => record.editorial_status === "published").length);
</script>

<template>
  <header class="page-head">
    <div class="page-width page-head-grid"><div><span>关于 VPScope</span><h1>让内容状态和证据边界可见</h1><p>技术指南、历史测评与工具目录采用不同的审核标准；记录数量不等于可发布内容。</p></div><Compass :size="34" /></div>
  </header>
  <section class="policy-band">
    <div id="editorial-policy" class="page-width about-intro">
      <strong>先核对证据，再把答案交给读者。</strong>
      <p>公开目录只收录已经逐篇阅读、回到当前官方资料核查，并按读者场景重写的内容。内部研究资料与编辑队列不作为站内入口、搜索结果或推荐依据。</p>
    </div>
    <div class="page-width about-status" aria-label="当前编辑状态">
      <div><span>当前状态</span><strong>公开内容持续复核</strong><p>数量用于说明公开目录范围，不代表推荐或排名。</p></div>
      <dl>
        <div><dt>已审核发布</dt><dd>{{ publishedCount.toLocaleString("zh-CN") }}</dd></div>
        <div><dt>公开内容</dt><dd>{{ publishedCount.toLocaleString("zh-CN") }}</dd></div>
        <div><dt>最近更新</dt><dd>2026.08</dd></div>
      </dl>
    </div>
    <div class="page-width policy-layout">
      <article><SearchCheck :size="24" /><h2>来源已读</h2><p>先读完整来源，保留来源专属笔记、哈希与阅读时间，再决定哪些信息值得进入公开稿。</p></article>
      <article><ShieldCheck :size="24" /><h2>事实已核</h2><p>重要主张已回到官方文档、标准、仓库或当前服务页面，并记录访问日期和不确定性。</p></article>
      <article><CheckCircle2 :size="24" /><h2>审核发布</h2><p>内容经过独立写作、引用检查、质量门和抽样复核，公开显示最近审核日期。</p></article>
      <article><BookOpenCheck :size="24" /><h2>持续更新</h2><p>版本、价格、库存、线路和服务条款会变化；文章会明确时间边界和下一次复核重点。</p></article>
    </div>
    <div id="privacy" class="page-width editorial-note">
      <strong>来源使用原则</strong>
      <p>内部研究材料只用于编辑，不公开原始正文、HTML、图片或私有审阅记录。技术文章优先引用项目与厂商官方文档；历史资料只保留必要归因，购买链接、联盟参数与优惠跳转一律移除。</p>
    </div>
  </section>
</template>
